import { Controller } from "@hotwired/stimulus"

// Client-side switching of everything that belongs to one file type: the
// parse-setting fields AND the editor cards (columns + mappings for a tabular
// type, the field-path overrides for XML). Every group renders and declares the
// formats it applies to via data-formats; only the ones matching the
// file-format select stay visible, so a not-yet-saved type switches them live
// while the type still saves through the shared Save button. A freshly
// connected field is toggled on connect too.
//
// One instance wraps the whole file-layout screen, because the select sits in
// the settings card while the cards it governs are rendered by a sibling
// component further down; a nested second instance would capture the select
// target and leave the cards without one.
export default class extends Controller {
  static targets = ["select", "field"]

  selectTargetConnected() {
    this.refresh()
  }

  fieldTargetConnected(field) {
    this.toggle(field)
  }

  refresh() {
    this.fieldTargets.forEach((field) => this.toggle(field))
  }

  toggle(field) {
    if (!this.hasSelectTarget) return

    const formats = (field.dataset.formats || "").split(/\s+/).filter(Boolean)
    field.hidden = !formats.includes(this.selectTarget.value)
  }
}
